import './sentry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from 'posthog-js/react';
import '@/_services/i18n';
import posthog from '@/_services/posthog';
import { getViteMode, getPosthogEnv, shouldEnablePosthog } from '@/_helpers/mainHelpers';

import reportWebVitals from '@/reportWebVitals';
import App from '@/App';
import '@/styles/main.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error("Root container not found. Ensure there is an element with id='root' in your HTML.");
}

const root = createRoot(container);

const env: ImportMetaEnv = import.meta.env;
const mode: string = getViteMode(env);
const { apiKey: posthogApiKey, apiHost: posthogApiHost } = getPosthogEnv(env);
const enablePosthog: boolean = shouldEnablePosthog(mode, posthogApiKey, posthogApiHost);

const app = (
  <StrictMode>
    {enablePosthog ? (
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </StrictMode>
);

root.render(app);

if (mode !== 'production') {
  reportWebVitals(console.log);
}